import axios from 'axios';
import api from './axios';
import { clearCacheByType, CACHE_KEYS } from '../utils/apiUtils';

/**
 * 设置当前选择的地区
 * @param {Object} data - 包含regionId的对象
 * @returns {Promise<Object>} - 返回设置后的地区信息
 */
export const setCurrentRegion = async (data) => {
  try {
    const response = await api.post('/dealer-regions/current', data);
    // 地区切换后清理与账号、统计相关的缓存，避免读取旧数据
    clearCacheByType(CACHE_KEYS.ACCOUNTS);
    clearCacheByType(CACHE_KEYS.STATS);
    return response.data;
  } catch (error) {
    console.error('设置当前地区失败:', error);
    throw error;
  }
};

/**
 * 获取当前选择的地区
 * @returns {Promise<Object>} - 返回当前地区信息
 */
export const getCurrentRegion = async () => {
  try {
    const response = await api.get('/dealer-regions/current');
    return response.data;
  } catch (error) {
    if (error.response) {
      const status = error.response.status;
      if (status === 404) {
        // 没有设置当前地区，返回null（这是正常情况）
        console.log('用户尚未设置地区，将显示地区选择器');
        return null;
      } else if (status === 403) {
        // 权限不足
        console.warn('用户权限不足，无法获取地区信息');
        return null;
      }
    }
    console.error('获取当前地区失败:', error);
    throw error;
  }
}; 
